document.addEventListener('DOMContentLoaded', () => {
    const CONFIG = {
        SELECTORS: {
            ELIGIBLE_OPTIONS: '.bold_option_radio .bold_option_value_element:has(input[value="Embroidery (Up to 5,000 Stitches)"], input[value="Printed Vinyl (Up to 5 Square Inches)"]) + .bold_option_value_title',
            ROLLOVER_CONTAINER_CHECK: '.bold_value_rollover',
            OPTION_VALUE_CONTAINER: '.bold_option_value',
        },
        OPTION_VALUES: {
            EMBROIDERY: 'Embroidery (Up to 5,000 Stitches)',
            PRINTED_VINYL: 'Printed Vinyl (Up to 5 Square Inches)',
        },
        MESSAGES: {
            EMBROIDERY_MSG: "If your design exceeds the standard 5,000 stitch count, additional stitches are priced at $2 per each 1,000 stitches. ",
            PRINTED_VINYL_MSG: 'If your design exceeds the standard 5" x 5" image field, extra space is priced at $5 per each additional 5" x 5"',
        },
        CLASSES: {
            ROLLOVER_CONTAINER: 'bold_value_rollover',
            ROLLOVER_MESSAGE: 'bold_value_rollover_message',
            TOOLTIP_BASE: 'bold_rollover_tooltip',
        }
    };

    const getTooltipSvg = () => `
        <span class="${CONFIG.CLASSES.TOOLTIP_BASE}">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
            </svg>
        </span>
    `;

    const createRolloverHtml = (messageText) => {
        const tooltip = getTooltipSvg();
        const message = `<span class="${CONFIG.CLASSES.ROLLOVER_MESSAGE}">${messageText}</span>`;
        return `<div class="${CONFIG.CLASSES.ROLLOVER_CONTAINER}">${tooltip}${message}</div>`;
    };

    const addRolloverToOption = (optionTitleElement) => {
        const optionValueContainer = optionTitleElement.closest(CONFIG.SELECTORS.OPTION_VALUE_CONTAINER);

        if (optionValueContainer.querySelector(CONFIG.SELECTORS.ROLLOVER_CONTAINER_CHECK)) {
            return;
        }

        const inputElement = optionTitleElement.previousElementSibling?.firstElementChild;

        if (!inputElement || !inputElement.value) {
            console.warn('Could not find associated input element for:', optionTitleElement);
            return;
        }

        const value = inputElement.value;
        let rolloverHtml = '';

        if (value === CONFIG.OPTION_VALUES.EMBROIDERY) {
            rolloverHtml = createRolloverHtml(CONFIG.MESSAGES.EMBROIDERY_MSG);
        } else if (value === CONFIG.OPTION_VALUES.PRINTED_VINYL) {
            rolloverHtml = createRolloverHtml(CONFIG.MESSAGES.PRINTED_VINYL_MSG);
        }

        if (rolloverHtml) {
            optionTitleElement.insertAdjacentHTML('afterend', rolloverHtml);
        }
    };

    const initializeRollovers = () => {
        const eligibleOptions = Array.from(document.querySelectorAll(CONFIG.SELECTORS.ELIGIBLE_OPTIONS));

        eligibleOptions.forEach(addRolloverToOption);
    };
    
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_changed', initializeRollovers);
});